import React from "react";

const Jobs = React.lazy(() => import("../pages/admin/Jobs"));
const Turnkeyautomotive = React.lazy(() => import("../pages/spmMachines/components/Turnkeyautomotive"));
const BaseLayout = React.lazy(() => import("../pages/BaseLayout"));
const Team = React.lazy(() => import("../pages/aboutus/component/Team"));
const HomePage = React.lazy(() => import("../pages/home/views/HomePage"));
const Solutions = React.lazy(() => import("../pages/solutions/views/Solutions"));
const Aboutus = React.lazy(() => import("../pages/aboutus/views/Aboutus"));
const CharityComponent = React.lazy(() => import("../pages/aboutus/component/CharityComponent"));
const Ourtech = React.lazy(() => import("../pages/aboutus/component/Ourtech"));
const Careers = React.lazy(() => import("../pages/aboutus/component/Careers"));
const Clients = React.lazy(() => import("../pages/aboutus/component/Clients"));
const Contactus = React.lazy(() => import("../pages/aboutus/component/Contactus"));
const PageLayoutcommon = React.lazy(() => import("../pages/aboutus/component/PageLayoutcommon"));
const AdminLogin = React.lazy(() => import("../login/Login"));

const AutomotiveSolutions = React.lazy(() => import("../pages/solutions/component/solutionindividual/Automotivesolution"));
const TireIndustrySolution = React.lazy(() => import("../pages/solutions/component/solutionindividual/Tireindustrysolution"));
const GlassIndustrySolution = React.lazy(() => import("../pages/solutions/component/solutionindividual/Glassindustrysolution"));
const PharmaIndustrySolution = React.lazy(() => import("../pages/solutions/component/solutionindividual/Pharmaindustrysolution"));
const CementIndustrySolution = React.lazy(() => import("../pages/solutions/component/solutionindividual/Cementindustrysolution"));
const ChemicalIndustrySolution = React.lazy(() => import("../pages/solutions/component/solutionindividual/Chemicalindustrysolution"));
const HealthcareIndustrySolution = React.lazy(() => import("../pages/solutions/component/solutionindividual/Healthcareindustrysolution"));
const PaperIndustrySolution = React.lazy(() => import("../pages/solutions/component/solutionindividual/Paperindustrysolution"));
const ElectronicsIndustrySolution = React.lazy(() => import("../pages/solutions/component/solutionindividual/Electronicsindustrysolution"));
const FoodBeverageIndustrySolution = React.lazy(() => import("../pages/solutions/component/solutionindividual/Foodbeverageindustrysolution"));
const AgroIndustrySolution = React.lazy(() => import("../pages/solutions/component/solutionindividual/Agroindustrysolution"));
const WaterIndustrySolution = React.lazy(() => import("../pages/solutions/component/solutionindividual/Waterindustrysolution"));

const CustomerSupport = React.lazy(() => import("../pages/home/component/service/CustomerSupport"));
const ProductSupport = React.lazy(() => import("../pages/home/component/service/ProductSupport"));
const AnnualMaintenance = React.lazy(() => import("../pages/home/component/service/AnnualMaintenance"));
const SalesService = React.lazy(() => import("../pages/home/component/service/SalesService"));
const OurInfoService = React.lazy(() => import("../pages/home/component/service/OurInfoService"));
const UserManuals = React.lazy(() => import("../pages/home/component/service/UserManuals"));

const AutomotiveSpm = React.lazy(() => import("../pages/spmMachines/AutomotiveSpm"));
const PharmaSpm = React.lazy(() => import("../pages/spmMachines/PharmaSpm"));
const ElectricalSpm = React.lazy(() => import("../pages/spmMachines/ElectricalSpm"));
const SoftwareSpm = React.lazy(() => import("../pages/spmMachines/SoftwareSpm"));
const SlipringsSpm = React.lazy(() => import("../pages/spmMachines/SlipringsSpm"));

const Softwareautomotive = React.lazy(() => import("../pages/spmMachines/components/Softwareautomotive"));
const Turnkeymachine = React.lazy(() => import("../pages/spmMachines/components/Turnkeymachine"));
const Turnkeywelding = React.lazy(() => import("../pages/spmMachines/components/Turnkeywelding"));
const Turnkeypages = React.lazy(() => import("../pages/spmMachines/components/Turnkeypages"));
const DairyProcessing = React.lazy(() => import("../pages/spmMachines/components/DiaryProcessing"));
const FoodProcessing = React.lazy(() => import("../pages/spmMachines/components/FoodProcessing"));
const BeverageProcessing = React.lazy(() => import("../pages/spmMachines/components/BeverageProcessing"));
const AutomotiveBranch = React.lazy(() => import("../pages/spmMachines/components/AutomotiveBranch"));
const FoodbeverageBranch = React.lazy(() => import("../pages/spmMachines/components/FoodbeverageBranch"));

const LandT = React.lazy(() => import("../pages/spmMachines/components/LandT"));
const Mitsu = React.lazy(() => import("../pages/spmMachines/components/Mitsu"));
const Siemens = React.lazy(() => import("../pages/spmMachines/components/Siemens"));
const Chemicalspm = React.lazy(() => import("../pages/spmMachines/components/Chemicalspm"));
const Cementspm = React.lazy(() => import("../pages/spmMachines/components/Cementspm"));
const Pharmabranch = React.lazy(() => import("../pages/spmMachines/components/Pharmabranch"));
const Electricalbranch = React.lazy(() => import("../pages/spmMachines/components/Electricalbranch"));
const Electricalthreepage = React.lazy(() => import("../pages/spmMachines/components/Electricalthreepage"));
const Certificates = React.lazy(() => import("../pages/spmMachines/components/Certificates"));
const Pacdrive = React.lazy(() => import("../pages/spmMachines/components/Pacdrive"));
const Softwarepage = React.lazy(() => import("../pages/spmMachines/components/Softwarepage"));
const Ourgallery = React.lazy(() => import("../pages/aboutus/component/Ourgallery"));
const Advancedsoftware = React.lazy(() => import("../pages/spmMachines/components/Advancedsoftware"));
const Filesection = React.lazy(() => import("../pages/aboutus/component/Filesection"));
const Robotics = React.lazy(() => import("../pages/robotics/Robotics"));
const RoboticsHub = React.lazy(() => import("../pages/robotics/RoboticsHub"));

// ✅ Fixed - now lazy loaded
const RoboticsBrands = React.lazy(() => import("../pages/robotics/RoboticsBrand"));

const FaceAuthentication = React.lazy(() => import("../pages/FaceAuthentication/Index"));
const TurkeyandSPM = React.lazy(() => import("../pages/spmMachines/components/TurkeysAndSPM"));
const Leads=React.lazy(() => import("../pages/leads/Leads"));
const ForgetPassword=React.lazy(()=>import("../login/ForgetPassword"));
const ChangePassword=React.lazy(()=>import("../login/ChangePassword"));
const AdminHome=React.lazy(()=>import("../pages/admin/Adminhome"));
const AdminLeads=React.lazy(()=>import("../pages/leads/AdminLeads"));
const AdminJobs=React.lazy(()=>import("../pages/admin/AdminJobs"));
const ManageUsers=React.lazy(()=>import("../pages/admin/ManagerUsers"));

const EmployeeForm =React.lazy(()=>import("../login/EmployeeForm"));
const RequirementsAdmin =React.lazy(()=>import("../pages/leads/Requirement"));
const AdminRequirements =React.lazy(()=>import("../pages/admin/AdminRequirement"));
const Privacy =React.lazy(()=>import("../pages/PrivacyPolicy"));


const routeConfig = [
  { path: "/", element: <HomePage /> },
  { path: "/solutions", element: <Solutions /> },
  { path: "/aboutus", element: <Aboutus /> },
  { path: "/csr", element: <CharityComponent /> },
  { path: "/ourtech", element: <Ourtech /> },
  { path: "/careers", element: <Careers /> },
  { path: "/clients", element: <Clients /> },
  { path: "/contact", element: <Contactus /> },
  { path: "/team", element: <Team /> },
  { path: "/careers/:role", element: <PageLayoutcommon /> },

  // ✅ Fixed - removed broken <careersDesc /> route
  // { path: "/apply", element: <careersDesc /> },

  { path: "/automotive", element: <AutomotiveSolutions /> },
  { path: "/tire", element: <TireIndustrySolution /> },
  { path: "/glass", element: <GlassIndustrySolution /> },
  { path: "/pharma", element: <PharmaIndustrySolution /> },
  { path: "/cement", element: <CementIndustrySolution /> },
  { path: "/chemical", element: <ChemicalIndustrySolution /> },
  { path: "/healthcare", element: <HealthcareIndustrySolution /> },
  { path: "/paper", element: <PaperIndustrySolution /> },
  { path: "/electronics", element: <ElectronicsIndustrySolution /> },
  { path: "/food-beverage", element: <FoodBeverageIndustrySolution /> },
  { path: "/agro", element: <AgroIndustrySolution /> },
  { path: "/water", element: <WaterIndustrySolution /> },

  { path: "/customer-support", element: <CustomerSupport /> },
  { path: "/product-support", element: <ProductSupport /> },
  { path: "/annual-maintenance", element: <AnnualMaintenance /> },
  { path: "/sales-service", element: <SalesService /> },
  { path: "/our-info", element: <OurInfoService /> },
  { path: "/user-manuals", element: <UserManuals /> },

  { path: "/automotive-spm", element: <AutomotiveSpm /> },
  { path: "/pharma-industry", element: <PharmaSpm /> },
  { path: "/electrical-panels", element: <ElectricalSpm /> },
  { path: "/software", element: <SoftwareSpm /> },
  { path: "/sliprings", element: <SlipringsSpm /> },
  { path: "/automotive-turnkey", element: <Turnkeyautomotive /> },
  { path: "/automotive-software", element: <Softwareautomotive /> },
  { path: "/machine-turnkey", element: <Turnkeymachine /> },
  { path: "/welding-turnkey", element: <Turnkeywelding /> },
  { path: "/turnkey-category", element: <Turnkeypages /> },
  { path: "/dairy-process", element: <DairyProcessing /> },
  { path: "/food-process", element: <FoodProcessing /> },
  { path: "/beverage-process", element: <BeverageProcessing /> },
  { path: "/automotive-category", element: <AutomotiveBranch /> },
  { path: "/foodbeverage-category", element: <FoodbeverageBranch /> },

  { path: "/lt-products", element: <LandT /> },
  { path: "/mitsubishi-products", element: <Mitsu /> },
  { path: "/siemens-products", element: <Siemens /> },
  { path: "/chemical-industry", element: <Chemicalspm /> },
  { path: "/cement-industry", element: <Cementspm /> },
  { path: "/pharmachemical-category", element: <Pharmabranch /> },
  { path: "/electrical-category", element: <Electricalbranch /> },
  { path: "/electrical-page", element: <Electricalthreepage /> },
  { path: "/certificates", element: <Certificates /> },
  { path: "/pacdrive", element: <Pacdrive /> },
  { path: "/gallery", element: <Ourgallery /> },
  { path: "/software-category", element: <Softwarepage /> },
  { path: "/advanced-software", element: <Advancedsoftware /> },
  { path: "/file", element: <Filesection /> },
  { path: "/robotics", element: <Robotics /> },
  { path: "/robotics-solutions", element: <RoboticsHub /> },
  { path: "/robotics-brands", element: <RoboticsBrands /> },
  { path: "/face-authentication", element: <FaceAuthentication /> },
  { path: "/turnkey-spm", element: <TurkeyandSPM /> },
  { path: "/anto-adminpanel", element: <Jobs /> },
  { path: "/leads", element: <Leads /> },
  { path: "/anto-login", element: <AdminLogin /> },
  {path:"/forgot-password",element:<ForgetPassword />},
  {path:"/change-password",element:<ChangePassword/>},
  {path:"/anto-adminhome",element:<AdminHome />},
  {path:"/Adminleads",element:<AdminLeads />},
  {path:"/anto-adminjobs",element:<AdminJobs />},
  {path:"/manage-users",element:<ManageUsers />},
  {path:"/elead",element:<EmployeeForm/>},
  {path:"/requirement",element:<RequirementsAdmin/>},
  {path:"/AdminRequirements",element:<AdminRequirements/>},
  {path:"/privacy-policy",element:<Privacy/>}
];

const route = [
  {
    path: "/",
    element: <BaseLayout />,
    children: routeConfig,
  },
];

export default route;